/**
 * Post送信処置
 * @param {*} selector 
 * @param {*} done 
 * @param {*} fail 
 */
exports.post = function (action, data, done, fail, type = 'json', param = null) {
    module.exports.send({
        type: 'post',
        url: action, 
        dataType: type, 
        data: data, 
    }, done, fail, param);
};

/**
 * PostJson送信処置
 * @param {*} selector 
 * @param {*} done 
 * @param {*} fail 
 */
exports.postJson = function (action, selector, done, fail, type = 'json', param = null) {

    let out = jsonSendFormat(selector);
    const contentType = 'application/json; charset=UTF-8';

    module.exports.send({
        type: 'post',
        url: action,
        contentType: contentType,
        dataType: type,
        data: JSON.stringify(out),
    }, done, fail, param);
};

/**
 * Post送信処置（オーバーレイ非表示）
 * @param {*} selector 
 * @param {*} done 
 * @param {*} fail 
 */
 exports.background = function (action, data, done, fail, type = 'json', param = null) {
    module.exports.send({
        type: 'post',
        url: action, 
        dataType: type, 
        data: data, 
        global: false, // グローバルな設定を読み込まない
    }, done, fail, param);
};
/**
 * Post送信処置（レスポンスをblobで受け取る）
 * @param {*} action 
 * @param {*} data 
 * @param {*} done 
 * @param {*} fail 
 */
exports.blob = function (action, data, done, fail) {
    module.exports.send({
        url: action,
        method: 'post',
        data: data,
        xhr: function() {
            const xhr = new XMLHttpRequest();
            xhr.responseType = 'blob'
            return xhr;
        } 
    }, done, fail);
};

/**
 * Post送信処置（レスポンスをblobで受け取る）
 * エラーメッセージを受け取れるver
 * @param {*} action 
 * @param {*} data 
 * @param {*} done 
 * @param {*} fail 
 */
exports.blob_with_error = function (action, data, done, fail) {
  var real;
  module.exports.send({
    url: action,
    method: 'post',
    data: data,
    xhr: function () {
        real = new XMLHttpRequest();
        real.responseType = 'blob';
        return real;
    },
    error: function (jqXHR) {
      var b = (real && real.response instanceof Blob) ? real.response : jqXHR.response;
      if (!b) return fail(jqXHR);
      b.text().then(function (t) {
        jqXHR.responseText = t;
        try { jqXHR.responseJSON = JSON.parse(t); } catch (e) {}
        fail(jqXHR);
      }).catch(function () {
        fail(jqXHR);
      });
    }
  }, done, null);
};

/**
 * File送信処置
 * @param {*} selector 
 * @param {*} done 
 * @param {*} fail 
 */
 exports.file = function (action, data, done, fail, type = 'json') {
    module.exports.send({
        type: 'post',
        url: action, 
        dataType: type, 
        data: data, 
        cache : false,
        contentType : false,
        processData : false,
    }, done, fail);
};
/**
 * get送信処置
 * @param {*} selector 
 * @param {*} done 
 * @param {*} fail 
 */
exports.get = function (action, done, fail, type = 'json') {
    module.exports.send({
        type: 'get',
        url: action, 
        dataType: type, 
    }, done, fail);
};
/**
 * formのサブミット処置
 * @param {*} selector 
 * @param {*} done 
 * @param {*} fail 
 */
exports.submit = function (selector, done, fail, type = 'json') {
      module.exports.send({
        type: $(selector).attr('method'),
        url: $(selector).attr('action'), 
        dataType: type, 
        data: $(selector).serialize() 
    }, done, fail);
};
/**
 * formのサブミット処置（データ指定有り）
 * @param {*} data
 * @param selector
 * @param {*} done
 * @param {*} fail
 * @param type
 * @param param
 * @param addHeader
 */
exports.submit_with_data = function (data, selector, done, fail, type = 'json', param = null, addHeader = null) {
    let params = {
        type: $(selector).attr('method'),
        url: $(selector).attr('action'),
        dataType: type,
        data: data
    };
    let setUp = {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') };
    if (addHeader) {
        setUp = Object.assign({}, setUp, addHeader);
    }
    $.ajaxSetup(setUp);
    $.ajax(params).done(function(results) {
        if (done != null) {
            done(results, param);
        }
    }).fail(function(xhr, status, errorThrown) {
        if (fail != null) {
            fail(xhr, status, errorThrown, param);
        }
    });
};
/**
 * formの確認用のサブミット処置
 * @param {*} selector 
 * @param {*} done 
 * @param {*} fail 
 */
 exports.confirm_submit = function (selector, action, done, fail, type = 'json') {
    module.exports.send({
        type: $(selector).attr('method'),
        url: action, 
        dataType: type, 
        data: $(selector).serialize()
    }, done, fail);
};

/**
 * formの確認用のサブミット処置(JSON形式)
 * @param {*} selector 
 * @param {*} done 
 * @param {*} fail 
 */
exports.confirmSubmitJson = function (selector, action, done, fail, type = 'json') {
    let out = jsonSendFormat(selector);
    const contentType = 'application/json; charset=UTF-8';
    module.exports.send({
        type: $(selector).attr('method'),
        contentType: contentType,
        url: action,
        dataType: type,
        data: JSON.stringify(out)
    }, done, fail);
};



/**
 * ajax送信処理
 * @param {*} params 
 * @param {*} done 
 * @param {*} fail 
 */
exports.send = function(params, done, fail, param = null) {
    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });
    $.ajax(params).done(function(results) {
        if (done != null) {
            done(results, param);
        }
    }).fail(function(xhr, status, errorThrown) {
        if (fail != null) {
            fail(xhr, status, errorThrown, param);
        }
    });
};


/**
 * formのサブミット処置(json形式で送信をする)
 * @param {*} selector 
 * @param {*} done 
 * @param {*} fail 
 */
exports.submitJson = function (selector, done, fail, type = 'json') {

    let out = jsonSendFormat(selector);
    const contentType = 'application/json; charset=UTF-8';


    module.exports.send({
        type: $(selector).attr('method'),
        url: $(selector).attr('action'), 
        contentType: contentType,
        dataType: type, 
        data: JSON.stringify(out)
        }, done, fail);
};

/**
 * json形式で送信するためのパラメータを組み立てる
 * @param {*} selector 
 */
function jsonSendFormat(selector){
    let out = {};
    const checkboxNames = new Set();
    $(selector).find('input[type="checkbox"]').each(function () {
        checkboxNames.add(this.name);
    });

    $(selector).serializeArray().forEach(({ name, value }) => {
        let path = [];

        name.replace(/([^[\]]+)|\[(.*?)\]/g, (_, a, b) => {
            path.push(a ?? b ?? '');
        });

        const v = (value === '' ? null : value);
        let cur = out;

        for (let i = 0; i < path.length; i++) {
            const key = path[i];
            const last = i === path.length - 1;
            const nextKey = path[i + 1];

            if (last) {
                if (key === '') {
                    cur.push(v);
                } else {
                    if (cur[key] === undefined) cur[key] = v;
                    else if (Array.isArray(cur[key])) cur[key].push(v);
                    else cur[key] = [cur[key], v];
                }
                return;
            }

            if (key === '') {
                if (cur.length === 0 || typeof cur[cur.length - 1] !== 'object') {
                    cur.push(nextKey === '' ? [] : {});
                }
                cur = cur[cur.length - 1];
            } else {
                if (cur[key] === undefined) {
                    cur[key] = nextKey === '' ? [] : {};
                }
                cur = cur[key];
            }
        }
    });

    // checkboxの場合値が配列になってしまうため 0 or 1の値にする
    Object.keys(out).forEach((key) => {
        if (checkboxNames.has(key)) {
            if (Array.isArray(out[key])) {
                out[key] = out[key].includes('1') ? '1' : '0';
            } else {
                out[key] = out[key] === '1' ? '1' : '0';
            }
        }
    });
    return out;

}